import { IsNotEmptyExpression } from "../../../Models/Comparators/IsNotEmptyExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class IsNotEmptyExpressionEvaluator implements IExpressionEvaluator<IsNotEmptyExpression>, IHasExpressionMetadata {
    get type(): string {
        return "IsNotEmpty";
    }

    private static _expressionPropertyNames: string[] = ["Value"];

    get expressionProperties(): string[] {
        return IsNotEmptyExpressionEvaluator._expressionPropertyNames;
    }

    evaluate(expression: IsNotEmptyExpression, context: IExpressionEvaluatorContext): MaybePromise {
        if (!expression.Value) {
            return true;
        }

        const value = context.Evaluator.evaluate(expression.Value, context);
        if (value instanceof Promise) {
            return value.then((resolvedValue) => !this.isEmpty(resolvedValue));
        }
        return !this.isEmpty(value);
    }

    private isEmpty(value: any): boolean {
        if (value == null || value === undefined) {
            return true;
        }
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        if (typeof value === "object") {
            return Object.keys(value).length === 0;
        }
        if (typeof value === "string") {
            return value.length === 0;
        }
        return false;
    }
}
